import { css } from "@compiled/react";
// @ts-ignore
import { useInView } from "react-intersection-observer";
import { useIntl } from "react-intl";

import {
    JiraOverlayTemplate,
    JPDOverlayTemplate
} from "@/components/signup/layouts/product-overlay-template";
import SiteActivation from "@/components/signup/site-activation";
import {
    useCohort,
    useUserContext,
    useLoggedInHasJira
} from "@/components/user-context";
import { useFeatureExposed } from "@/utils/feature-exposed";

import { WelcomeBackHeading } from "../../../loom/components";
import { LoggedInJpdNewUser } from "../free/new-user";

export const LoggedInJpdStandard = () => {
    const { ref, inView } = useInView();
    const cohort = useCohort();
    const isLoggedInHasJira = useLoggedInHasJira();

    // Only fire useFeatureExposed if cohort is not "new-user" to avoid double exposure (NewUser component calls useFeatureExposed as well)
    useFeatureExposed("gwp-7053-jpd-lofi-signup", "Test", {
        conditions: [inView, cohort !== "new-user"],
        metadata: {
            hasJira: isLoggedInHasJira,
            cohort: cohort,
            tier: "standard"
        }
    });

    if (cohort === "new-user") {
        return <LoggedInJpdNewUser />;
    }

    if (isLoggedInHasJira) {
        return (
            <div ref={ref}>
                <JiraOverlayTemplate size="sm">
                    <Content />
                </JiraOverlayTemplate>
            </div>
        );
    } else {
        return (
            <div ref={ref}>
                <JPDOverlayTemplate size="sm">
                    <Content />
                </JPDOverlayTemplate>
            </div>
        );
    }
};

const Content = () => {
    const {
        user: { name }
    } = useUserContext();

    const { formatMessage } = useIntl();

    return (
        <>
            <h1 css={headerCss}>
                <WelcomeBackHeading name={name} />
            </h1>
            <h2 css={subheadingCss}>
                {formatMessage({
                    id: "LoomTemplate.loggedInHero.subheader",
                    defaultMessage:
                        "Sites are shared spaces to organize work, teams, and projects."
                })}
            </h2>
            <SiteActivation />
            <footer css={footerCss}>
                {formatMessage({
                    id: "JiraSoftwarePageTemplate.loggedInHero.recatcha",
                    defaultMessage:
                        "This page is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply."
                })}
            </footer>
        </>
    );
};

const headerCss = css({
    margin: 0,
    textAlign: "center"
});

const subheadingCss = css({
    fontSize: 16,
    fontWeight: 400,
    textAlign: "center",
    lineHeight: "24px",
    fontFamily: "Charlie Text",
    margin: "16px 0 0"
});

const footerCss = css({
    fontSize: 12,
    fontWeight: 400,
    margin: 0,
    fontFamily: "Charlie Text"
});
